<template>
  <div class="aplayer"></div>
</template>
<script type="text/babel">
import APlayer from 'aplayer'
export default {
  props: {
    narrow: {
      type: Boolean,
      default: false
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    mutex: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: '#b7daff'
    },
    mode: {
      type: String,
      default: 'circulation'
    },
    preload: {
      type: String,
      default: 'auto'
    },
    music: {
      type: [Object, Array],
      required: true,
      validator (value) {
        let songs
        if (!(value instanceof Array)) {
          songs = [value]
        } else {
          songs = value
        }
        for (let i = 0; i < songs.length; i++) {
          let song = songs[i]
          if (!song.url || !song.title || !song.author) {
            song.title = song.title || 'Untitled'
            song.author = song.author || 'Unknown'
            return false
          }
        }
        return true
      }
    }
  },
  data () {
    return {
      control: null
    }
  },
  watch: {
    music (music) {
      if (this.control.option !== undefined) {
        this.control.option.music = music
        this.control.setMusic(0)
        if (this.autoplay) {
          this.control.play()
        }
        this.$emit('change', music)
      }
    }
  },
  mounted () {
    this.control = new APlayer({
      element: this.$el,
      narrow: this.narrow,
      autoplay: this.autoplay,
      mutex: this.mutex,
      theme: this.theme,
      preload: this.preload,
      mode: this.mode,
      music: this.music
    })
  }
}
</script>
